import footer from './components/footer';
var processInclude = require('base/util');

export default {
    init: () => {
        processInclude(footer);
    }
};